import { COOKIE_NAME_TOKEN, EMPTY_STRING } from '../constants/common'

export function getCookieItem(sKey) {
  if (!sKey) {
    return null
  }

  const key = encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')
  const reg = new RegExp(`(?:(?:^|.*;)\\s*${key}\\s*\\=\\s*([^;]*).*$)|^.*$`)

  return decodeURIComponent(document.cookie.replace(reg, '$1')) || null
}

export function hasCookieItem(sKey) {
  if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
    return false
  }

  return new RegExp(
    `(?:^|;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=`
  ).test(document.cookie)
}

export function removeCookieItem(sKey, sPath, sDomain) {
  if (!hasCookieItem(sKey)) {
    return false
  }

  document.cookie = `${encodeURIComponent(
    sKey
  )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${
    sDomain ? `; domain=${sDomain}` : EMPTY_STRING
  }${sPath ? `; path=${sPath}` : EMPTY_STRING}`

  return true
}

export function getTokenCookie() {
  return getCookieItem(COOKIE_NAME_TOKEN)
}

export function removeTokenCookie() {
  return removeCookieItem(COOKIE_NAME_TOKEN, '/', '.idwell.at')
}
